<template>
    <div id="dashboardAnnouncementsSection">
        <section id="Announcements" class="annoucements card">
            <h2 id="announcement-header" class="card-header">
                <a id="announcementsanchor" name="announcementsanchor"></a>
                <button class="btn btn-link" data-toggle="collapse" data-target=".announcement-card-body" aria-expanded="true" aria-controls="announcement-card-body" aria-label="Toggle Announcements Section (Mobile View)" @click="collapsePanel">
                    <span class="icon icon-clock-1"></span>Reminders
                </button>
            </h2>
            <div v-if="announcementsAreLoaded == 1" class="announcement-card-body card-body collapse" aria-labelledby="announcement-header" id="announcement-card-body">
                <div v-if="notNullOrEmpty(webToolsFeed.items)">
                    <div v-for="item in webToolsFeed.items" :key="item.title">
                        <div class="block">
                            <h3><a :href="item.link">{{item.title}}</a></h3>
                            <span v-html="item.description"></span>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p>No announcements at this time.</p>
                </div>
            </div>
            <div v-else class="announcement-card-body card-body collapse" aria-labelledby="announcement-header" id="announcement-card-body">
                <div v-if="announcementsAreLoaded == 2">
                    <p>We are having trouble loading this section. This could be because we can't find a record for you or we are having connectivity problems.</p>
                </div>
                <div v-else>
                    <spinner></spinner>
                </div>   
            </div>   
        </section>
        <section v-if="notNullOrEmpty(collegeFeed)" id="CollegeAnnouncements" class="college-annoucements card">
            <h2 id="college-announcement-header" class="card-header">
                <a id="collegeannouncementsanchor" name="collegeannouncementsanchor"></a>
                <button class="btn btn-link" data-toggle="collapse" data-target=".college-announcement-card-body" aria-expanded="true" aria-controls="college-announcement-card-body" @click="collapsePanel" aria-label="Toggle College News Section (Mobile View)">
                    <span class="icon icon-chat-1"></span>College News
                </button>
            </h2>
            <div class="college-announcement-card-body card-body collapse" aria-labelledby="college-announcement-header">
                <span v-html="collegeFeed"></span>
            </div>
        </section>
        
        <div v-if="announcementsAreLoaded == 1 && collegeApiFeed != null && notNullOrEmpty(collegeApiFeed.items)">
            <div v-for="(item, index) in collegeApiFeed.items" :key="index">
                <section class="college-annoucements card">
                    <h2 :id="'college-announcement-header-' + index" class="card-header">
                        <a name="collegeannouncementsanchor"></a>
                        <button class="btn btn-link" data-toggle="collapse" :data-target="'.coll-body-' + index" aria-expanded="true" :aria-controls="'coll-body-' + index" @click="collapsePanel" aria-label="Toggle College News Section (Mobile View)">
                            <span class="icon icon-chat-1"></span>{{item.contentTitle}}
                        </button>
                    </h2>
                    <div :id="'college-announcement-card-body-' + index" :class="'college-announcement-card-body card-body collapse coll-body-' + index" :aria-labelledby="'college-announcement-header-' + index">
                        <span v-html="item.contentMessage"></span>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import spinner from "../components/spinner.vue"
    export default {
        name: 'Announcements',
        components: {spinner},
        computed: {
            announcementsAreLoaded() { return this.$store.state.announcementsAreLoaded},
            webToolsFeed() { 
                return this.$store.state.announcements.webToolsFeed
            },
            collegeFeed() {
                if (this.$store.state.announcements.collegeFeed && this.$store.state.announcements.collegeFeed != null) {
                    return this.$store.state.announcements.collegeFeed;
                } else {
                    return null;
                }
            },
            collegeApiFeed() {
                if (this.$store.state.announcements.collegeAPIFeed && this.$store.state.announcements.collegeAPIFeed != null) {
                    return this.$store.state.announcements.collegeAPIFeed;
                } else {
                    return null;
                }
            }
        },
        mounted() {
            if (this.$store.state.announcementsAreLoaded == 0) {
                this.$store.dispatch("getAnnouncements");
            }
        }
    };
</script>